import createStateMachine from '../../gameStateMachine/index.js';
import createAgent from '../index.js';
import createAgentInterpreter from '../agentInterpreter.js';
export default function getRequestOrders(gameProperties, agentSide, agentPlayerId, strategyIngredients = []) {
    const { game, scenario, hexProperties, rules } = gameProperties;
    const agentMachine = createStateMachine({
        game,
        scenario,
        hexProperties,
    });
    const agent = createAgent(game.hexes, scenario, agentSide, hexProperties, ensureEnoughOrders(strategyIngredients));
    const agentInterpreter = createAgentInterpreter(agent, agentMachine, rules);
    return agentInterpreter.makeMove(game.state, agentPlayerId);
}
function ensureEnoughOrders(strategyIngredients = []) {
    const ingredients = [...strategyIngredients];
    const lastIngredient = ingredients[ingredients.length - 1];
    if (!lastIngredient || lastIngredient.name !== 'doNothing' || lastIngredient.maxOrders != -1) {
        ingredients.push({ name: 'doNothing', maxOrders: -1 });
    }
    return ingredients;
}
